import { Button } from '../../../../components/Button/Button'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const CrossClientHeader = () => {
  const navigate = useNavigate()

  const handleBackButtonClicked = () => {
    navigate({
      pathname: '/cross-client',
    })
  }

  return (
    <div className='zocks-pl-2.0'>
      <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
        <i className='bi bi-chevron-left' />
      </Button>
    </div>
  )
}
